export const EMAILADDRESS = 'info@aral-cardkomfort.de'
export const NONPROD_ONEFLEETURL = 'https://ui.onefleet.preprod.superfleet-enabler.com/'
export const PROD_ONEFLEETURL = 'https://onefleet.aral.de/'